import React, { useState } from 'react';
import styled from 'styled-components';
import Home from '../Home';
import PPCHeroImage from '../../img/ppc-blogg.jpg'

// --- Styled Components ---

const PageContainer = styled.div`
  font-family: 'Arial', sans-serif;
  color: #333;
  //  padding-top: 50px;
  background: #fff;
`;

const HeroSection = styled.section`
  padding: 100px 5%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  //max-width: 1200px;
  margin: 0 auto;
  border-radius: 20px;
  margin-top: 20px;
  margin-bottom: 60px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, rgba(255,165,0,0.1) 0%, rgba(255,165,0,0.05) 100%);

  /* Background image with overlay */
  &::before {
  padding: 100px 5%;
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 100vw;
    height: 70%;
    background: url(${PPCHeroImage}) no-repeat center center;
    background-size: cover;
    border-radius: 0 20px 20px 0;
  }

  /* White overlay for better text visibility */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.95) 0%,
      rgba(255, 255, 255, 0.85) 45%,
      rgba(255, 255, 255, 0.4) 70%,
      transparent 100%
    );
    z-index: 1;
  }

  @media (max-width: 992px) {
    flex-direction: column;
    padding: 60px 5%;
    
    &::before {
      width: 100%;
      border-radius: 20px;
      opacity: 0.3;
    }
    
    &::after {
      background: rgba(255, 255, 255, 0.9);
    }
  }
`;

const HeroContent = styled.div`
  max-width: 600px;
  position: relative;
  z-index: 2;
  
  @media (max-width: 992px) {
    text-align: center;
    margin-bottom: 40px;
  }
`;

const HeroTitle = styled.h1`
  font-size: 3em;
  font-weight: 800;
  line-height: 1.2;
  color: #ff6b00;
  margin-bottom: 20px;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.8);

  span {
    color: #2c3e50;
    display: block;
    font-size: 0.8em;
    margin-top: 10px;
    text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.8);
  }

  @media (max-width: 768px) {
    font-size: 2.2em;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 1.2em;
  color: #555;
  line-height: 1.6;
  margin-bottom: 30px;
  font-weight: 500;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.8);
`;

const LeadCount = styled.div`
  font-size: 4em;
  font-weight: bold;
  color: #ff6b00;
  margin-top: 10px;
  margin-bottom: 30px;
  text-shadow: 2px 2px 4px rgba(255, 255, 255, 0.8);

  @media (max-width: 768px) {
    font-size: 3em;
  }
`;

const HeroImage = styled.div`
  max-width: 400px;
  position: relative;
  z-index: 2;
  
  @media (max-width: 992px) {
    display: none;
  }
`;
const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.5em;
  font-weight: 700;
  margin: 60px auto 40px;
  padding: 15px 30px;
  color: #2c3e50;
  border-bottom: 4px solid #ff6b00;
  display: inline-block;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 4px;
    background: #3498db;
  }
  
  @media (max-width: 768px) {
    font-size: 2em;
    margin: 40px auto 30px;
  }
`;

const IssuesSection = styled.section`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 80px 5%;
  text-align: center;
  color: white;
`;

const IssuesTitle = styled(SectionTitle)`
  color: white;
  border-bottom-color: #ffd700;
  background: transparent;
  box-shadow: none;
  
  &::after {
    background: #ffd700;
  }
`;

const IssueList = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
`;

const IssueItem = styled.div`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 30px;
  border-radius: 15px;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  }
`;

const IssueIcon = styled.div`
  width: 70px;
  height: 70px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2em;
  color: #ffd700;
`;

const IssueContent = styled.div``;

const IssueName = styled.h3`
  font-size: 1.5em;
  color: #fff;
  margin-bottom: 15px;
  font-weight: 600;
`;

const IssueDescription = styled.p`
  font-size: 1.1em;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
`;

const ServicesSection = styled.section`
  padding: 80px 5%;
  text-align: center;
  background: #f8f9fa;
`;

const ServicesTitle = styled(SectionTitle)`
  color: #2c3e50;
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
`;

const ServiceCard = styled.div`
  background: #fff;
  padding: 40px 30px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, #ff6b00, #ff8c00);
  }

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  }
`;

const CardIcon = styled.div`
  font-size: 3em;
  color: #ff6b00;
  margin-bottom: 20px;
`;

const CardTitle = styled.h4`
  font-size: 1.4em;
  font-weight: 700;
  margin-bottom: 15px;
  color: #2c3e50;
`;

const CardText = styled.p`
  font-size: 1em;
  color: #666;
  line-height: 1.6;
`;

// --- Enhanced Ads Types Section ---

const AdsTypesSection = styled.section`
  padding: 80px 5%;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 20px;
  margin-bottom: 60px;
`;

const SubTitle = styled.h3`
  font-size: 1.3em;
  font-weight: 400;
  margin-bottom: 50px;
  color: #666;
  font-style: italic;
`;

const AdsTypeButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 50px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    gap: 10px;
  }
`;

const AdButton = styled.button`
  background-color: ${(props) => (props.$active ? '#ff6b00' : 'transparent')};
  color: ${(props) => (props.$active ? '#fff' : '#ff6b00')};
  border: 2px solid #ff6b00;
  padding: 12px 24px;
  font-size: 1em;
  font-weight: 600;
  cursor: pointer;
  border-radius: 25px;
  transition: all 0.3s ease;
  min-width: 180px;

  &:hover {
    background-color: #ff6b00;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(255, 107, 0, 0.3);
  }

  @media (max-width: 600px) {
    min-width: 140px;
    padding: 10px 20px;
    font-size: 0.9em;
  }
`;

const AdContentBox = styled.div`
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  padding: 50px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 50px;
  text-align: left;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -50%;
    width: 100%;
    height: 200%;
    background: radial-gradient(circle, rgba(255,107,0,0.1) 0%, transparent 70%);
  }

  @media (max-width: 992px) {
    flex-direction: column;
    text-align: center;
    padding: 40px 30px;
    gap: 30px;
  }
`;

const AdText = styled.div`
  flex: 1;
  color: #fff;
`;

const AdTitle = styled.h3`
  font-size: 1.8em;
  font-weight: 700;
  margin-bottom: 20px;
  color: #ffd700;
`;

const AdDescription = styled.p`
  font-size: 1.1em;
  line-height: 1.7;
  margin-bottom: 25px;
  color: #ecf0f1;
`;

const AdBenefits = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const AdBenefit = styled.li`
  padding: 8px 0;
  padding-left: 25px;
  position: relative;
  font-size: 1em;
  color: #bdc3c7;

  &::before {
    content: '✓';
    position: absolute;
    left: 0;
    color: #27ae60;
    font-weight: bold;
  }
`;

const AdImage = styled.div`
  flex: 0 0 300px;
  height: 250px;
  background: linear-gradient(45deg, #3498db, #9b59b6);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2em;
  font-weight: bold;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 2;

  @media (max-width: 992px) {
    flex: 0 0 auto;
    width: 100%;
    max-width: 400px;
  }
`;

// --- Results Section ---

const ResultsSection = styled.section`
  padding: 80px 5%;
  max-width: 1200px;
  margin: 0 auto;
`;

const ResultsHeader = styled(SectionTitle)`
  background: #1a1a1a;
  color: #fff;
  margin-bottom: 50px;
`;

const ResultsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ResultItem = styled.div`
  display: flex;
  align-items: flex-start;
  background: #252525;
  padding: 25px;
  border-radius: 8px;
  border-left: 5px solid #ffa500;
`;

const IconWrapper = styled.div`
  min-width: 50px;
  height: 50px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8em;
  color: #ffa500;
  border-radius: 50%;
  background: #333;

  /* Custom styling for A/B test icon */
  ${(props) => props.$abtest && `
    background: #ffa500;
    color: #1a1a1a;
    font-size: 1.2em;
    font-weight: bold;
  `}

  @media (max-width: 600px) {
    margin-right: 15px;
    min-width: 40px;
    height: 40px;
    font-size: 1.5em;
  }
`;

const ResultContent = styled.div`
  text-align: left;
`;

const ResultTitle = styled.h4`
  font-size: 1.3em;
  font-weight: 600;
  color: #fff;
  margin-bottom: 5px;

  @media (max-width: 600px) {
    font-size: 1.1em;
  }
`;

const ResultDescription = styled.p`
  font-size: 0.95em;
  color: #aaa;
  line-height: 1.5;
`;

const FaqContainer = styled.section`
  background: #f4f4f9; /* Light, contrasting background for the section */
  padding: 60px 5%;
  max-width: 1200px;
  margin: 40px auto;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
`;

const SectionHeader = styled.h2`
  text-align: center;
  font-size: 2.5em;
  font-weight: 700;
  margin-bottom: 50px;
  color: #333;
  padding: 10px 20px;
  background: linear-gradient(to right, #f0e68c, #fff, #f0e68c); /* Gold-like gradient for background */
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    font-size: 2em;
    margin-bottom: 40px;
  }
`;

const FaqItem = styled.div`
  border: 1px solid #ddd;
  margin-bottom: 15px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #fff;
`;

const QuestionButton = styled.button`
  width: 100%;
  background-color: #fff;
  color: #333;
  padding: 18px 25px;
  text-align: left;
  border: none;
  font-size: 1.1em;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: #fff8e1; /* Light hover effect */
  }
`;

const AnswerContent = styled.div`
  max-height: ${(props) => (props.$isOpen ? '500px' : '0')}; /* Transition for height */
  transition: max-height 0.4s ease-in-out;
  overflow: hidden;
  padding: ${(props) => (props.$isOpen ? '0 25px 25px' : '0 25px')};
`;

const AnswerText = styled.p`
  margin: 0;
  color: #555;
  line-height: 1.6;
`;

const ToggleIcon = styled.span`
  font-size: 1.5em;
  color: #ffa500;
  transform: rotate(${(props) => (props.$isOpen ? '180deg' : '0')});
  transition: transform 0.3s;
`;

const WhyChooseUsSection = styled.section`
  padding: 60px 5%;
  max-width: 1200px;
  margin: 0 auto;
`;



const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureCard = styled.div`
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s ease;
  min-height: 250px; /* Ensure cards have similar height */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }
`;

const FeatureIcon = styled.div`
  font-size: 3em;
  color: #ffa500; /* Primary orange color */
  margin-bottom: 15px;
`;

const FeatureTitle = styled.h3`
  font-size: 1.3em;
  font-weight: 700;
  margin-bottom: 10px;
  color: #333;
`;

const FeatureDescription = styled.p`
  font-size: 0.95em;
  color: #666;
  line-height: 1.5;
`;

// --- SEO Ranking Form Section ---

const SEORankingFormSection = styled.section`
  background-color: #1a1a1a; /* Dark background */
  color: #fff;
  padding: 80px 5%;
  text-align: center;
  margin-top: 60px;
`;

const FormHeader = styled.div`
  max-width: 800px;
  margin: 0 auto 50px;
`;

const FormTitle = styled.h2`
  font-size: 2.2em;
  font-weight: 700;
  margin-bottom: 15px;
  color: #ffa500;

  @media (max-width: 768px) {
    font-size: 1.8em;
  }
`;

const FormSubtitle = styled.p`
  font-size: 1.1em;
  color: #aaa;
  line-height: 1.6;
`;

const FormGrid = styled.form`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  max-width: 900px;
  margin: 0 auto 30px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FormInput = styled.input`
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #444;
  border-radius: 5px;
  background-color: #333;
  color: #fff;
  font-size: 1em;
  &::placeholder {
    color: #888;
  }
  &:focus {
    outline: none;
    border-color: #ffa500;
  }
`;

const FormTextArea = styled.textarea`
  grid-column: 1 / -1; /* Spans full width */
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #444;
  border-radius: 5px;
  background-color: #333;
  color: #fff;
  font-size: 1em;
  min-height: 100px;
  resize: vertical;
  &::placeholder {
    color: #888;
  }
  &:focus {
    outline: none;
    border-color: #ffa500;
  }
`;

const SubmitButton = styled.button`
  background-color: #ffa500;
  color: #1a1a1a;
  border: none;
  padding: 12px 30px;
  font-size: 1.1em;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  grid-column: 1 / -1;
  width: auto;
  justify-self: start;

  &:hover {
    background-color: #ff9900;
  }

  @media (max-width: 768px) {
    justify-self: center;
  }
`;

const SecurityInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 0.9em;
  color: #aaa;
  margin-top: 20px;
`;

const SecurityIcon = styled.span`
  font-size: 1.2em;
  color: #ffa500;
`;

// --- We Specialize In Section ---

const SpecializationSection = styled.section`
  background-color: #fff; /* White background for this section */
  padding: 60px 5%;
  text-align: center;
`;

const SpecializationTitle = styled.h2`
  font-size: 2.2em;
  font-weight: 700;
  margin-bottom: 50px;
  color: #333;

  @media (max-width: 768px) {
    font-size: 1.8em;
  }
`;

const SpecializationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  max-width: 1000px;
  margin: 0 auto;

  @media (max-width: 992px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const BrandLogo = styled.div`
  background-color: #f9f9f9;
  border: 1px solid #eee;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;

  img {
    max-width: 100%;
    max-height: 100%;
    filter: grayscale(100%); /* Simulating the black and white logos */
    opacity: 0.7;
    transition: all 0.3s ease;

    &:hover {
      filter: grayscale(0%);
      opacity: 1;
    }
  }
`;
// --- FAQ Data ---

const faqData = [
  {
    question: "What exactly is PPC (Pay-Per-Click) marketing?",
    answer: "PPC, or Pay-Per-Click, is an online advertising model where advertisers pay a fee each time one of their ads is clicked. Instead of earning visits organically, you are essentially buying visits to your site. It is most commonly associated with search engines like Google Ads, where businesses bid on keywords that users are searching for.",
  },
  {
    question: "How quickly can I expect to see results from a PPC campaign?",
    answer: "Unlike SEO which takes time to build, PPC provides almost immediate visibility. Once your campaign is set up and approved (usually within 24 hours), your ads can start appearing. You will begin generating data, clicks, and potential leads/sales immediately, though optimization for best performance typically takes a few weeks to a couple of months.",
  },
  {
    question: "What is Quality Score and why is it important?",
    answer: "Quality Score (QS) is a metric from 1-10 used by Google to determine the quality and relevance of your keywords, ads, and landing pages. A higher Quality Score means Google views your ads as more relevant, which often results in a better Ad Rank (position) and a lower Cost-Per-Click (CPC).",
  },
  {
    question: "How is the advertising budget handled by SRK Softwares?",
    answer: "Your advertising budget (the money spent directly on Google/Facebook/etc. for clicks) is paid directly to the ad platform (e.g., Google Ads, Meta Ads). SRK Softwares only manages the campaign for a separate management fee. This ensures complete transparency and that you retain full ownership and control of your ad spend.",
  },
  {
    question: "What are 'Negative Keywords' and why do you use them?",
    answer: "Negative keywords are terms you exclude from your PPC campaigns. They prevent your ads from showing for irrelevant searches. For example, if you sell 'office space for rent,' we would add 'free,' 'movie,' or 'for sale' as negative keywords to avoid wasting your budget on non-converting clicks.",
  },
  {
    question: "Will PPC work for a small business or a niche industry?",
    answer: "Yes, PPC is highly effective for businesses of all sizes, especially niche industries. Because PPC allows for highly specific keyword and demographic targeting, it ensures your limited budget is spent only on the most qualified prospects actively searching for your unique product or service. When done right, PPC is one of the most powerful tools for local and niche growth.",
  },
];



const Ppc = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [activeAdType, setActiveAdType] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const adTypes = [
    {
      title: "GOOGLE SHOPPING ADS",
      description: "Transform your product catalog into engaging visual ads that appear directly in Google search results. Google Shopping Ads showcase your products with images, prices, and store information, making it incredibly easy for customers to find and purchase what they're looking for.",
      benefits: [
        "Show products with images and prices directly in search",
        "Higher conversion rates for e-commerce businesses",
        "Target customers ready to make purchases",
        "Automatic synchronization with your product feed"
      ]
    },
    {
      title: "SEARCH ADS",
      description: "Appear at the top of Google search results when potential customers are actively searching for products or services like yours. Search Ads are text-based advertisements that target specific keywords, ensuring your business is visible to high-intent users.",
      benefits: [
        "Reach customers at the moment they're searching",
        "Pay only when someone clicks your ad",
        "Highly targeted keyword-based advertising",
        "Immediate visibility and quick results"
      ]
    },
    {
      title: "DISPLAY ADS",
      description: "Expand your reach across millions of websites, apps, and Google-owned properties with visually engaging banner ads. Display advertising helps build brand awareness and retarget visitors who have previously interacted with your business.",
      benefits: [
        "Massive reach across the Google Display Network",
        "Visual advertising with images and rich media",
        "Advanced targeting options (demographics, interests)",
        "Excellent for brand awareness and retargeting"
      ]
    },
    {
      title: "VIDEO ADS",
      description: "Capture attention with compelling video content on YouTube and across the web. Video Ads allow you to tell your brand's story, demonstrate products, and engage audiences through the power of motion and sound.",
      benefits: [
        "High engagement through visual storytelling",
        "YouTube and video partner placements",
        "Multiple formats: skippable, non-skippable, bumper",
        "Powerful for building emotional connections"
      ]
    },
    {
      title: "LOCAL SERVICES ADS",
      description: "Get your service business in front of local customers who are actively looking for providers in your area. Local Services Ads appear at the very top of search results and include Google-guaranteed badges to build trust and credibility.",
      benefits: [
        "Prime positioning at the top of search results",
        "Google-guaranteed badge builds customer trust",
        "Pay per lead instead of per click",
        "Ideal for local service businesses"
      ]
    }
  ];

  return (
    <Home>
      <PageContainer>
        {/* Enhanced Hero Section */}
        <HeroSection>
          <HeroContent>
            <HeroTitle>
              Premier PPC Management Services in Patna
              <span>Drive Qualified Traffic & Maximize Your ROI with Expert Google Ads Management</span>
            </HeroTitle>
            <HeroSubtitle>
              As Patna's leading PPC agency, we specialize in creating data-driven advertising campaigns that deliver measurable results. 
              Whether you're targeting local customers or expanding nationally, our expert team optimizes every click for maximum conversion.
            </HeroSubtitle>
            <LeadCount>97%</LeadCount>
            <HeroSubtitle>of our clients see significant ROI improvement within first 90 days</HeroSubtitle>
          </HeroContent>
          <HeroImage />
        </HeroSection>

        {/* Enhanced Issues Section */}
        <IssuesSection>
          <IssuesTitle>Common PPC Challenges We Solve</IssuesTitle>
          <IssueList>
            <IssueItem>
              <IssueIcon>💰</IssueIcon>
              <IssueContent>
                <IssueName>Budget Management</IssueName>
                <IssueDescription>
                  Wasting ad spend on ineffective campaigns? We implement smart bidding strategies and continuous optimization 
                  to ensure every rupee delivers maximum value and reaches your target audience efficiently.
                </IssueDescription>
              </IssueContent>
            </IssueItem>

            <IssueItem>
              <IssueIcon>📉</IssueIcon>
              <IssueContent>
                <IssueName>Ad Fatigue & Performance</IssueName>
                <IssueDescription>
                  Seeing declining click-through rates? Our team constantly refreshes ad creatives, tests new approaches, 
                  and rotates messaging to keep your campaigns fresh and engaging for your audience.
                </IssueDescription>
              </IssueContent>
            </IssueItem>

            <IssueItem>
              <IssueIcon>🎯</IssueIcon>
              <IssueContent>
                <IssueName>Precision Targeting</IssueName>
                <IssueDescription>
                  Reaching the wrong audience? We leverage advanced targeting options including demographics, interests, 
                  behaviors, and custom intent audiences to connect you with potential customers most likely to convert.
                </IssueDescription>
              </IssueContent>
            </IssueItem>
          </IssueList>
        </IssuesSection>

        {/* Enhanced Ads Types Section */}
        <AdsTypesSection>
          <SectionTitle>Google Ads Management Services in Patna</SectionTitle>
          <SubTitle>Comprehensive Advertising Solutions Tailored for Bihar Businesses</SubTitle>

          <AdsTypeButtons>
            {adTypes.map((ad, index) => (
              <AdButton 
                key={index}
                $active={activeAdType === index}
                onClick={() => setActiveAdType(index)}
              >
                {ad.title}
              </AdButton>
            ))}
          </AdsTypeButtons>

          <AdContentBox>
            <AdText>
              <AdTitle>{adTypes[activeAdType].title}</AdTitle>
              <AdDescription>
                {adTypes[activeAdType].description}
              </AdDescription>
              <AdBenefits>
                {adTypes[activeAdType].benefits.map((benefit, index) => (
                  <AdBenefit key={index}>{benefit}</AdBenefit>
                ))}
              </AdBenefits>
            </AdText>
            <AdImage>
              {adTypes[activeAdType].title} Preview
            </AdImage>
          </AdContentBox>

          {/* Additional Content for Patna-specific Services */}
          <div style={{textAlign: 'left', marginTop: '50px', background: 'white', padding: '40px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)'}}>
            <h3 style={{color: '#2c3e50', marginBottom: '20px', fontSize: '1.8em'}}>Why Choose Our Patna PPC Services?</h3>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px'}}>
              <div>
                <h4 style={{color: '#ff6b00', marginBottom: '15px'}}>Local Market Expertise</h4>
                <p style={{color: '#666', lineHeight: '1.6'}}>
                  As a Patna-based agency, we understand the unique dynamics of the Bihar market. 
                  We know the local consumer behavior, seasonal trends, and competitive landscape to create campaigns that resonate with your target audience.
                </p>
              </div>
              <div>
                <h4 style={{color: '#ff6b00', marginBottom: '15px'}}>Multilingual Campaign Management</h4>
                <p style={{color: '#666', lineHeight: '1.6'}}>
                  We create campaigns in Hindi, English, and other regional languages to effectively connect with diverse audiences across Bihar and Eastern India.
                </p>
              </div>
              <div>
                <h4 style={{color: '#ff6b00', marginBottom: '15px'}}>Local Business Focus</h4>
                <p style={{color: '#666', lineHeight: '1.6'}}>
                  Specialized strategies for Patna's key industries including education, real estate, healthcare, and local services that drive relevant traffic and qualified leads.
                </p>
              </div>
            </div>
          </div>
        </AdsTypesSection>

        {/* Enhanced Services Section */}
        <ServicesSection>
          <ServicesTitle>Industry-Specific PPC Solutions</ServicesTitle>
          <ServicesGrid>
            <ServiceCard>
              <CardIcon>🏠</CardIcon>
              <CardTitle>Real Estate PPC</CardTitle>
              <CardText>
                Target home buyers, sellers, and investors in Patna and across Bihar. We create compelling property ads 
                that drive qualified leads for residential, commercial, and rental properties with precise location targeting.
              </CardText>
            </ServiceCard>

            <ServiceCard>
              <CardIcon>🎓</CardIcon>
              <CardTitle>Education & Coaching</CardTitle>
              <CardText>
                Reach students and parents searching for coaching institutes, universities, and skill development courses. 
                Our education-focused campaigns drive admissions and enrollments for Patna's growing education sector.
              </CardText>
            </ServiceCard>

            <ServiceCard>
              <CardIcon>🏥</CardIcon>
              <CardTitle>Healthcare Marketing</CardTitle>
              <CardText>
                Connect patients with your healthcare services. We optimize campaigns for hospitals, clinics, 
                and medical professionals to attract patients searching for specific treatments and healthcare solutions.
              </CardText>
            </ServiceCard>

            <ServiceCard>
              <CardIcon>💼</CardIcon>
              <CardTitle>Local Business Services</CardTitle>
              <CardText>
                Grow your local business with targeted ads that reach customers in specific Patna neighborhoods. 
                Perfect for restaurants, retailers, service providers, and other local businesses looking to increase foot traffic and local sales.
              </CardText>
            </ServiceCard>
          </ServicesGrid>
        </ServicesSection>


      {/* Measurable Results Section */}
      <ResultsSection>
        <ResultsHeader>Measurable Results Through Effective Advertising Campaigns</ResultsHeader>
        <ResultsGrid>

          {/* Navigating the Audit Process with Confidence */}
          <ResultItem>
            <IconWrapper>&#128269;</IconWrapper>
            <ResultContent>
              <ResultTitle>Navigating the Audit Process with Confidence</ResultTitle>
              <ResultDescription>
                In the world of business and finance, audits are a critical component to ensure transparency and compliance. Our experts delve into your accounts, identifying and analyzing prevailing aspects, liabilities, and opportunities as you navigate this essential process for your organization.
              </ResultDescription>
            </ResultContent>
          </ResultItem>

          {/* Unlocking Success with Keyword Research and Analysis */}
          <ResultItem>
            <IconWrapper>&#128202;</IconWrapper>
            <ResultContent>
              <ResultTitle>Unlocking Success with Keyword Research and Analysis</ResultTitle>
              <ResultDescription>
                Keywords are the main engines that drive visibility to your products or services online. Our in-depth keyword research services empower you with the knowledge to target the right audience, improve SEO, and create content that resonates. We will help you harness the power of keywords for organic growth and paid visibility.
              </ResultDescription>
            </ResultContent>
          </ResultItem>

          {/* Maximizing ROI through Paid Search Optimization */}
          <ResultItem>
            <IconWrapper>&#128184;</IconWrapper>
            <ResultContent>
              <ResultTitle>Maximizing ROI through Paid Search Optimization</ResultTitle>
              <ResultDescription>
                Paid search optimization is the key to making the most of your advertising budget. Our dedicated team specializes in refining your paid search campaigns to ensure maximum effectiveness. We make sure every penny spent is invested where they matter most. Explore how we can elevate your online advertising strategy to drive higher returns on investment (ROI).
              </ResultDescription>
            </ResultContent>
          </ResultItem>

          {/* Boosting Success with Conversion Rate Optimization */}
          <ResultItem>
            <IconWrapper>&#128176;</IconWrapper>
            <ResultContent>
              <ResultTitle>Boosting Success with Conversion Rate Optimization</ResultTitle>
              <ResultDescription>
                Conversion rate optimization (CRO) is the secret sauce behind turning website visitors into loyal customers. Our CRO services are focused on improving your site's structure and design to eliminate friction, enhance conversion rates. Discover the potential for higher sales and engagement as we optimize your digital presence for maximum results.
              </ResultDescription>
            </ResultContent>
          </ResultItem>

          {/* A/B Testing Showdown: Uncovering the Differences */}
          <ResultItem>
            <IconWrapper $abtest>A/B</IconWrapper>
            <ResultContent>
              <ResultTitle>A/B Testing Showdown: Uncovering the Differences</ResultTitle>
              <ResultDescription>
                A/B testing is a powerful tool for optimizing your digital strategies, but not all approaches are created equal in this showdown. Our experts meticulously compare different testing methodologies and performance metrics for each. Discover which A/B testing approach aligns best with your goals and empowers you to make data-driven decisions for future growth.
              </ResultDescription>
            </ResultContent>
          </ResultItem>

          {/* Elevate Your Google Ads Performance with an Account Audit */}
          <ResultItem>
            <IconWrapper>&#9733;</IconWrapper>
            <ResultContent>
              <ResultTitle>Elevate Your Google Ads Performance with an Account Audit</ResultTitle>
              <ResultDescription>
                Unlock the full potential of your Google Ads campaigns through our comprehensive account audit. Our expert analysis pinpoints areas for improvement, identifies untapped opportunities, and recommends strategic adjustments to boost your ROI. Gain a competitive edge in the digital advertising landscape with actionable insights from our Google Ads account audit.
              </ResultDescription>
            </ResultContent>
          </ResultItem>

          {/* Harnessing the Neighborhood Connection: Nextdoor Advertising */}
          <ResultItem>
            <IconWrapper>&#128100;</IconWrapper>
            <ResultContent>
              <ResultTitle>Harnessing the Neighborhood Connection: Nextdoor Advertising</ResultTitle>
              <ResultDescription>
                Discover the power of Nextdoor Advertising in reaching hyper-local audiences. Our Nextdoor Advertising services enable businesses to connect with their neighborhood community, fostering trust and loyalty. Explore how you can tap into the neighborhood conversation and grow your presence with Nextdoor Advertising.
              </ResultDescription>
            </ResultContent>
          </ResultItem>
        </ResultsGrid>
      </ResultsSection>

<WhyChooseUsSection>
        <SectionHeader>Why Choose SRK Softwares For PPC Marketing</SectionHeader>
        <FeaturesGrid>
          {/* Expertise In Paid Advertising */}
          <FeatureCard>
            <FeatureIcon>&#128187;</FeatureIcon> {/* Computer icon */}
            <FeatureTitle>Expertise In Paid Advertising</FeatureTitle>
            <FeatureDescription>
              Our team is made up of experts who really know paid advertising. We're like having a group of online advertising champions working for you. We help you figure out exactly who you need to reach and get the right people at the right time.
            </FeatureDescription>
          </FeatureCard>

          {/* Tailored Strategies */}
          <FeatureCard>
            <FeatureIcon>&#128087;</FeatureIcon> {/* T-shirt/Clothing icon */}
            <FeatureTitle>Tailored Strategies</FeatureTitle>
            <FeatureDescription>
              We don't just use one-size-fits-all. We know how you choose clothes that fit you perfectly. That's why we create special advertising plans that match your business. We learn all about your goals and then make a plan to get you what you want to achieve. Then we follow that plan specifically for your business.
            </FeatureDescription>
          </FeatureCard>

          {/* Result-Oriented Approach */}
          <FeatureCard>
            <FeatureIcon>&#127919;</FeatureIcon> {/* Target/Dartboard icon */}
            <FeatureTitle>Result-Oriented Approach</FeatureTitle>
            <FeatureDescription>
              We're not here to play games. Our main goal is to get you real results. We focus on getting you real results, like more people visiting your website, more sales, or more people knowing your products. When you succeed, we succeed.
            </FeatureDescription>
          </FeatureCard>

          {/* Data-Driven Decisions */}
          <FeatureCard>
            <FeatureIcon>&#128200;</FeatureIcon> {/* Chart/Graph icon */}
            <FeatureTitle>Data-Driven Decisions</FeatureTitle>
            <FeatureDescription>
              Think of us as detectives who love numbers. We look at a lot of hidden information to figure out what works best for your ads. We carefully examine all the numbers related to your ads. This helps us know what to say, and when to show them.
            </FeatureDescription>
          </FeatureCard>

          {/* Keyword Mastery */}
          <FeatureCard>
            <FeatureIcon>&#128273;</FeatureIcon> {/* Key icon */}
            <FeatureTitle>Keyword Mastery</FeatureTitle>
            <FeatureDescription>
              Ever notice how you type words when you're looking for something? Those words are like magic keys that unlock your products or services for people who want them. We are experts at finding those words. We use these words to make sure your ads show up when people are looking for you.
            </FeatureDescription>
          </FeatureCard>

          {/* Compelling Ad Creatives */}
          <FeatureCard>
            <FeatureIcon>&#127912;</FeatureIcon> {/* Paint palette icon */}
            <FeatureTitle>Compelling Ad Creatives</FeatureTitle>
            <FeatureDescription>
              We're like storytellers who create ads that people can't help but notice. Our ads are like exciting stories that grab people's attention. We use cool pictures and words that make your special offers to make sure your ads stand out and get seen.
            </FeatureDescription>
          </FeatureCard>

          {/* Continuous Monitoring */}
          <FeatureCard>
            <FeatureIcon>&#128065;</FeatureIcon> {/* Eye icon */}
            <FeatureTitle>Continuous Monitoring</FeatureTitle>
            <FeatureDescription>
              We don't just set up your ads and leave them. We keep a close eye on them, like watching your plants to help them grow. We constantly check to see how well they're doing. If something's not right, we quickly change things to make them even more effective.
            </FeatureDescription>
          </FeatureCard>

          {/* Transparent Reporting */}
          <FeatureCard>
            <FeatureIcon>&#128203;</FeatureIcon> {/* Document icon */}
            <FeatureTitle>Transparent Reporting</FeatureTitle>
            <FeatureDescription>
              We believe in being honest and open. We'll tell you exactly how well your ads are performing. You'll know how many people saw your ads, how many clicked on them, and how many turned into customers. This way, you'll always know what's happening with your ads.
            </FeatureDescription>
          </FeatureCard>

          {/* Dedicated Client Support */}
          <FeatureCard>
            <FeatureIcon>&#128100;</FeatureIcon> {/* User/Person icon */}
            <FeatureTitle>Dedicated Client Support</FeatureTitle>
            <FeatureDescription>
              We're here for you whenever you need us. If you have questions or want to try new ideas, we're just a message away. We're like your co-pilot, always there, working together to make your business shine.
            </FeatureDescription>
          </FeatureCard>
        </FeaturesGrid>
      </WhyChooseUsSection>

      {/* SEO Ranking Form Section */}
      <SEORankingFormSection>
        <FormHeader>
          <FormTitle>We're Here to Help you get Best SEO Ranking</FormTitle>
          <FormSubtitle>
            Fill out the form to get in touch with an SEO marketing experts for Custom SEO Solutions
          </FormSubtitle>
        </FormHeader>

        <FormGrid>
          <FormInput type="text" placeholder="What's your name?" />
          <FormInput type="email" placeholder="Your Email address?" />
          <FormInput type="tel" placeholder="Your Phone number" />
          <FormInput type="text" placeholder="Select Country" /> {/* This should ideally be a select dropdown */}
          <FormInput type="text" placeholder="Your Business Name" />
          <FormInput type="text" placeholder="Your Website URL" />
          <FormTextArea placeholder="Your Message" />
          <SubmitButton type="submit">YES, SEND ME PROPOSAL</SubmitButton>
        </FormGrid>

        <SecurityInfo>
          <SecurityIcon>&#128274;</SecurityIcon> {/* Lock icon */}
          <span>WE GUARANTEE 100% SECURITY OF YOUR INFORMATION: This information is to contact you for further assistance. We do not Spam Or Sell your information.</span>
        </SecurityInfo>
      </SEORankingFormSection>

      {/* We Specialize In Section */}
      <SpecializationSection>
        <SpecializationTitle>We Specialize In</SpecializationTitle>
        <SpecializationGrid>
          <BrandLogo><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_AdWords_logo.svg/1280px-Google_AdWords_logo.svg.png" alt="Google Adwords" /></BrandLogo>
          <BrandLogo><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Bing_Ads_logo.svg/1280px-Bing_Ads_logo.svg.png" alt="Bing Ads" /></BrandLogo>
          <BrandLogo><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Amazon_icon.svg/2048px-Amazon_icon.svg.png" alt="Amazon" /></BrandLogo>
          <BrandLogo><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Facebook_F_icon.svg/2048px-Facebook_F_icon.svg.png" alt="Facebook Ads" /></BrandLogo>
          <BrandLogo><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/LinkedIn_Logo.svg/1280px-LinkedIn_Logo.svg.png" alt="LinkedIn" /></BrandLogo>
          <BrandLogo><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Pinterest-logo.svg/2048px-Pinterest-logo.svg.png" alt="Pinterest" /></BrandLogo>
          <BrandLogo><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Twitter-logo.svg/2048px-Twitter-logo.svg.png" alt="Twitter" /></BrandLogo>
          <BrandLogo><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/Yahoo%21_icon.svg/2048px-Yahoo%21_icon.svg.png" alt="Yahoo" /></BrandLogo>
        </SpecializationGrid>
      </SpecializationSection>

        <FaqContainer>
      <SectionHeader>
        Frequently Asked <span>Questions</span>
      </SectionHeader>

      {faqData.map((item, index) => (
        <FaqItem key={index}>
          <QuestionButton onClick={() => toggleFAQ(index)}>
            {item.question}
            <ToggleIcon $isOpen={openIndex === index}>&#9660;</ToggleIcon> {/* Down arrow icon */}
          </QuestionButton>
          <AnswerContent $isOpen={openIndex === index}>
            <AnswerText>{item.answer}</AnswerText>
          </AnswerContent>
        </FaqItem>
      ))}
    </FaqContainer>
      </PageContainer>
    </Home>
  );
};

export default Ppc;